module.exports = __webpack_public_path__ + "static/media/people-fill-primary2.6bb5f00c.svg";